import { AbstractDashboardRemoteDataSource } from "@/modules/dashboard/remote/AbstractDashboardRemoteDataSource";
import { DashboardRemoteDataSource } from "@/modules/dashboard/remote/DashboardRemoteDataSource";
import { AbstractEventsRemoteDataSource } from "@/modules/events/remote/AbstractEventsRemoteDataSource";
import { EventsRemoteDataSource } from "@/modules/events/remote/EventsRemoteDataSource";
import { AbstractExecutiveDashboardRemoteDataSource } from "@/modules/executiveDashboard/remote/AbstractExecutiveDashboardRemoteDataSource";
import { ExecutiveDashboardRemoteDataSource } from "@/modules/executiveDashboard/remote/ExecutiveDashboardRemoteDataSource";
import { AbstractResourceRemoteDataSource } from "@/modules/resources/remote/AbstractResourceRemoteDataSource";
import { ResourceRemoteDataSource } from "@/modules/resources/remote/ResourceRemoteDataSource";
import { AbstractUserRemoteDataSource } from "@/modules/users/remote/AbstractUserRemoteDataSource";
import { UserRemoteDataSource } from "@/modules/users/remote/UserRemoteDataSource";
import { AbstractEventTypeRemoteDataSource } from "@/modules/eventType/remote/AbstractEventTypeRemoteDataSource";
import { EventTypeRemoteDataSource } from "@/modules/eventType/remote/EventTypeRemoteDataSource";
import { AbstractAuditRemoteDataSource } from "@/modules/audit/remote/AbstractAuditRemoteDataSource";
import { AuditRemoteDataSource } from "@/modules/audit/remote/AuditRemoteDataSource";

export const eventsRemoteDataSource: AbstractEventsRemoteDataSource =
  new EventsRemoteDataSource();

export const resourceRemoteDataSource: AbstractResourceRemoteDataSource =
  new ResourceRemoteDataSource();

export const dashboardRemoteDataSource: AbstractDashboardRemoteDataSource =
  new DashboardRemoteDataSource();

export const executiveDashboardRemoteDataSource: AbstractExecutiveDashboardRemoteDataSource =
  new ExecutiveDashboardRemoteDataSource();

export const userRemoteDataSource: AbstractUserRemoteDataSource =
  new UserRemoteDataSource();

export const auditRemoteDataSource: AbstractAuditRemoteDataSource =
  new AuditRemoteDataSource();

export const eventTypeRemoteDataSource: AbstractEventTypeRemoteDataSource =
  new EventTypeRemoteDataSource();
